import React from "react";

import Super5Concurso from "src/static/tutorial/concurso/super-5";
import Super6Concurso from "src/static/tutorial/concurso/super-6";
import Lotinha from "src/static/tutorial/concurso/lotinha";
import LotinhaDivertidu from "src/static/tutorial/concurso/lotinha-divertidu";
import SenaDivertidu from "src/static/tutorial/concurso/sena-divertidu";
import QuinaDivertidu from "src/static/tutorial/concurso/quina-divertidu";
import KenoDivertidu from "src/static/tutorial/concurso/keno-divertidu";

const jogoID = {
  1515: "lotinha",
  9595: "lotinha-divertidu",
  2525: "lotinha-divertidu",
  777: "keno-divertidu",
  6666: "sena-divertidu",
  5555: "quina-divertidu",
  555: "super-5",
  666: "super-6",
};

export function getConcursoTutorial(selectedContest) {
  const contest = jogoID[selectedContest.objTipoJogo.sntTipoJogoSistema];
  const name = selectedContest.objTipoJogo.vchNome.toUpperCase();

  switch (contest) {
    case "quina-divertidu":
      return <QuinaDivertidu name={name} />;
    case "sena-divertidu":
      return <SenaDivertidu name={name} />;
    case "lotinha-divertidu":
      return <LotinhaDivertidu name={name} />;
    case "keno-divertidu":
      return <KenoDivertidu name={name} />;
    case "super-5":
      return <Super5Concurso name={name} />;
    case "super-6":
      return <Super6Concurso name={name} />;
    case "lotinha":
      return <Lotinha name={name} />;
    default:
      return <React.Fragment />;
  }
}



// WEBPACK FOOTER //
// ./src/static/tutorial/concurso/index.jsx